import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import {BarBase} from "./bar_base";

class BarNorm extends BarBase {
    protected allChartOptions(): Options {
        const options: Options = {
            yAxis: {
                tickPositions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            },
        };

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {registerPlugin(BarNorm)}